import { TestableComponent } from 'common/interfaces';
import { getClassName } from 'common/utils';
import React, { ReactNode } from 'react';

interface DetailedInfoProps extends TestableComponent {
  text: ReactNode;
  subText?: string | string[];
}

export default function DetailedInfo({ text, subText, testId }: DetailedInfoProps) {
  const renderSubText = () => {
    if (!subText) return null;
    if (Array.isArray(subText)) {
      return subText.map((item, index) => (
        <span
          key={index}
          className={getClassName('menu-detailed-sub-text', {
            active: index >= subText.length - 1
          })}
          data-test-id={`${testId}-subtitle-${index}`}
        >
          {item}
        </span>
      ));
    }
    return <span className="menu-detailed-sub-text">{subText}</span>;
  };

  return (
    <div className="menu-detailed-info-wrapper" data-test-id={testId}>
      <span className="menu-separator" />
      <span
        className={getClassName('menu-detailed-info-text', { active: !subText })}
        data-test-id={`${testId}-title`}
      >
        {text}
      </span>
      {renderSubText()}
    </div>
  );
}
